import React, { useContext, useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { BookingAccount } from '../../../../../types/BookingAccount.types';
import DataContext from '../../../../../context/DataProvider/DataContext';

function numberIsIdentical(
  inputValue: DataTypeProvider.ValueEditorProps['value'],
  currentValue: string | undefined,
  listOfBookingAccounts: BookingAccount[],
): boolean {
  if (currentValue) {
    if (inputValue?.toString() === currentValue) {
      return false;
    }
    return true;
  }
  for (let index = 0; index < listOfBookingAccounts.length; index += 1) {
    if (inputValue === listOfBookingAccounts[index].booking_account_nr.toString()) {
      return true;
    }
  }

  return false;
}

function isNumberWith10Digits(num: string) {
  const numStr = num.toString();
  if (numStr.length >= 10) {
    if (/^\d+$/.test(numStr)) {
      return true;
    }
  }

  return false;
}

function validateValue(
  value: DataTypeProvider.ValueEditorProps['value'],
  initialValue: string | undefined,
  listOfBookingAccounts: BookingAccount[],
): { error: boolean; helperText: string } {
  const nameIsIdentical: boolean = numberIsIdentical(value, initialValue, listOfBookingAccounts);
  if (!value) {
    return {
      error: true,
      helperText: 'Pflichtfeld',
    };
  }
  if (isNumberWith10Digits(value)) {
    return {
      error: true,
      helperText: 'Max 10 Zeichen lang',
    };
  }
  if (nameIsIdentical) {
    return {
      error: true,
      helperText: 'Buchungskontonummer bereits vorhanden',
    };
  }
  return {
    error: false,
    helperText: '',
  };
}

function NumberEditor({ value, onValueChange, disabled }: DataTypeProvider.ValueEditorProps) {
  const { bookingAccount } = useContext(DataContext);
  const [helperText, setHelperText] = useState('');
  const [error, setError] = useState(false);

  const { current: initialValue } = useRef(value);

  useEffect(() => {
    const valid = validateValue(value, initialValue, bookingAccount);
    setError(valid.error);
    setHelperText(valid.helperText);
  }, [value]);

  return (
    <Box>
      <TextField
        disabled={initialValue && disabled}
        value={value || ''}
        type="number"
        onChange={(event) => onValueChange(event.target.value)}
        error={error}
        helperText={initialValue && disabled ? '' : helperText}
      />
    </Box>
  );
}

export default NumberEditor;
